
import { Component } from '@angular/core';
import { DirectionService } from '../../services/direction.service';
import { ActivatedRoute, RouterModule } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { switchMap } from 'rxjs';
import { NotificationService } from '../../services/notification.service';
import { SocketService } from '../../services/socket.service';
import { IndicatorsService } from '../../services/indicators.service';
import { FormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { ButtonModule } from 'primeng/button';
import { RadioButtonModule } from 'primeng/radiobutton';
import { TableModule } from 'primeng/table';
import { TagModule } from 'primeng/tag';
import { TooltipModule } from 'primeng/tooltip';
import { ProjectFileAuditorComponent } from '../../../project-file-auditor/project-file-auditor.component';
import { NotificationTypesEnum } from '../../interfaces';
import { DialogModule } from 'primeng/dialog';
import { WebViewerComponent } from '../../webviewer/webviewer.component';
import { SignalRService } from '../../services/signal-r.service';

@Component({
  selector: 'app-ondicator-file-audit-single',
  standalone: true,
  imports: [
    DialogModule,
    WebViewerComponent,
    ProjectFileAuditorComponent,
    TooltipModule,
    ButtonModule,
    TagModule,
    TableModule,
    TranslateModule,
    RadioButtonModule,
    FormsModule,
    RouterModule
  ],
  templateUrl: './indicator-file-audit-single.component.html',
  styleUrl: './indicator-file-audit-single.component.scss'
})
export class IndicatorFileAuditSingleComponent {
  isFileViewer = false;
  strategyId = 0;
  indicatorId = 0;
  fileId = 0;
  assessmentModal = false;
  selectedFile: any;
  dir!: 'rtl' | 'ltr';
  locale!: "ar" | "en";
  outcome = {} as any;
  constructor(
    private route: ActivatedRoute,
    private indicatorsService: IndicatorsService,
    private toastr: ToastrService,
    private directionService: DirectionService,
    private notificationService: NotificationService,
    private indicatorService: IndicatorsService,
    private signalrService: SignalRService,

  ) {
  }
  ngOnInit(): void {
    this.route.queryParams.pipe(switchMap(({ strategyId, parentEntityId, subEntityId }) => {
      console.log("queryParams", strategyId);
      this.strategyId = strategyId
      this.indicatorId = parentEntityId
      this.fileId = subEntityId
      return this.indicatorsService.listSingleOutcomesFiles(strategyId, parentEntityId, subEntityId);
    })).subscribe((x: any) => {
      this.outcome = x['data']['outcome'] as any;
    })

    this.directionService.direction$.subscribe((dir) => {
      this.dir = dir;

      this.locale = dir == "rtl" ? "ar" : "en";
    })

  }

  MediaFileStatusEnum = {
    pending: 'pending',
    approved: 'approved',
    rejected: 'rejected'
  };

  FileStatusValues = {
    pending: "قيد المراجعة",
    approved: "معتمد",
    rejected: "مرفوض"
  };

  openAssessmentModal(file: any) {
    this.assessmentModal = true;
    this.selectedFile = { ...file, comments: file.comments.trim() };
  }
  closeAssessmentModal() {
    this.assessmentModal = false;
    this.selectedFile = null;
  }

  getFileIcon(type: string) {
    switch (type) {
      case 'image/jpeg':
      case 'image/png':
        return "fa-solid fa-file-image";
      case 'application/vnd.openxmlformats-officedocument.wordprocessingml.document':
        return "fa-solid fa-file-word";
      case 'application/pdf':
        return "fa-solid fa-file-pdf";
      case 'video/mp4':
      case 'video/x-msvideo':
      case 'video/quicktime':
      case 'video/x-matroska':
        return "fa-solid fa-file-video";
      default:
        return "fa-solid fa-file";
    }
  }
  assessOutput() {


    this.indicatorsService.reviewAuditFile(this.strategyId, { ... this.selectedFile, fileType: this.selectedFile.entityType }).subscribe((response: any) => {
      this.assessmentModal = false;
      this.outcome.files = this.outcome.files.map((x: any) => {
        if (x.id == this.selectedFile.id) {
          return { ...this.selectedFile }
        } else {
          return x;
        }
      })
      this.toastr.success(response['data']['message'])

      this.signalrService.reconnectIfDisconnected();

      this.notificationService.pushAuditRequest(
        +this.strategyId, {
        id: +this.selectedFile.id,
        parentEntityId: +this.indicatorId,
        subEntityId: +this.selectedFile.subEntityId,
        type: NotificationTypesEnum.outcome_proof_audit_response
      },
        this.locale
      )


    })
  };
  downloadFile(file: any) {
    console.log("selected file", this.selectedFile);
    this.indicatorService.downloadOutcomeProof(this.strategyId, file.indicator_id, file.outcome_id, file.id).subscribe((x) => {
      console.log("blob", x);
      const blob = new Blob([x], { type: x.type });
      const url = window.URL.createObjectURL(blob);
      const anchor = document.createElement('a');
      anchor.href = url;
      anchor.download = "";
      anchor.click();
      window.URL.revokeObjectURL(url);
    });
  }
  openFileViewer(file: any) {
    this.selectedFile = file;
    console.log("selected file", this.selectedFile);
    this.isFileViewer = true
  }
}
